import React, {useCallback, useEffect, useState} from 'react';
import {Button, Layout, theme} from "antd";
import HeaderNotify from "./components/notify";
import HeaderSetting from "./components/setting";
import HeaderSearch from "./components/search";
import {AllowButton} from "../../custom/permission/Can";
import {ActionKeys, SubjectName} from "../../custom/permission/Ability";
import '@dogoo/do-app-list/dist/index.scss'
import NewHeaderAccount from "./components/account/account";
import {getMe} from "../../api/system/admin/user-account";
import {useLocation, useSearchParams} from "react-router-dom";
import {KeyFilter as Field} from "../../components/hrm/report/constant/keyFilter";
import FilterModalParent from "../../components/hrm/report/modal/FilterModalParent";
import {mapTag} from "../../components/hrm/report/common/mapTag";
import {mapTitleDate} from "../../components/hrm/report/common/mapTitleDate";
import {KeyConstant} from "../../components/hrm/report/constant/keyConstant";
import dayjs from "dayjs";
import {ProductList} from '@dogoo/do-products-list'
import {useMainAppContext} from '../../hooks/useMainAppContext'
import {t} from "i18next";

const {Header} = Layout

function LayoutHeader() {
    const {useToken} = theme;
    const {token} = useToken();
    const location = useLocation()
    const str = location.pathname.split('/')
    const [searchParams] = useSearchParams()
    const [visible, setVisible] = useState(false)
    const [hasFilter, setHasFilter] = useState(searchParams.get(Field.department_id) ||
        searchParams.get(Field.type_report))
    const{ allProductsService } = useMainAppContext()

    useEffect(() => {
        const departmentId = searchParams.get(Field.department_id);
        const typeReport = searchParams.get(Field.type_report);
        setHasFilter(departmentId || typeReport);
    }, [searchParams]);

    const mapSearchFilter = useCallback(() => {
        if (str[3] && str[3] === "report") {
            return <>
                <Button className={"flex items-center"}
                        style={{
                            height: 44,
                            width: 103,
                            background: hasFilter ? token.colorPrimary : ""
                        }}
                        onClick={() => setVisible(true)}
                        icon={
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20"
                                           fill="none">
                                <path d="M5.79297 10H15.793M3.29297 5H18.293M8.29297 15H13.293"
                                      stroke= {!hasFilter ? token.colorPrimary : "#FFF"}
                                      stroke-width="1.66667"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                />
                            </svg>
                        }
                >

                    <span
                        style={{
                            color: hasFilter ? "white" : token.colorPrimary,
                            fontSize: 14,
                            fontWeight: 600,
                        }}>
                      {t("tnp.components.report.filter")}
                    </span>
                </Button>
            </>
        }

        return <HeaderSearch/>
    }, [hasFilter, str, token]);

    return (
        <Header
            style={{
                height: "var(--header-height)",
                background: "var(--primary-bg)",
                padding: "0 24px",
                lineHeight: "var(--primary-line-height)",
            }}
            className={"flex items-center justify-between"}
        >
            <div
                 style={{
                     fontSize: 18,
                     fontWeight: 600,
                     color : "#101828"
                 }}
            >
                {
                    str[3] && str[3] === "report" &&
                    <span>
                       {t("tnp.components.common.text29")}&nbsp;
                        {mapTag(searchParams.get("type"),
                            searchParams.get(Field.START_DATE), searchParams.get(Field.END_DATE))}
                        &nbsp;
                        {mapTitleDate(searchParams.get("type") ? searchParams.get("type") : KeyConstant.THIRTY_DAYS_AGO,
                            searchParams.get("startDate") ? dayjs(searchParams.get("startDate")).toDate() :
                                dayjs().subtract(28, "days").toDate(),
                            searchParams.get("endDate") ? dayjs(searchParams.get("endDate")).toDate() :
                                dayjs().subtract(1, "days").toDate())}
                    </span>
                }
            </div>
            <div className="flex items-center">
                {mapSearchFilter()}
                <HeaderNotify/>
                <AllowButton action={ActionKeys.SETTING} subjectName={SubjectName.tnp} conditionObject={{}}>
                    {
                        getMe()?.paymentStatus && <HeaderSetting/>
                    }
                </AllowButton>
                <ProductList
                    data={allProductsService}
                />
                <div className="ml-[12px]">
                    <NewHeaderAccount/>

                </div>
            </div>

            <FilterModalParent visible={visible} onCancel={() => setVisible(false)}/>

        </Header>
    );
}

export default LayoutHeader;
